module.exports = __webpack_public_path__ + "static/webstorm1-ea7da7e30f359f1f85a67968169f1734.png";